export default __webpack_public_path__ + "static/media/allianceblock.dcc08be5.png";